import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateTemplateScreensMutation, UpdateTemplateScreensMutationVariables } from '@/graphql/generated/graphql';
import { UpdateTemplateScreensDocument } from '@/graphql/generated/graphql';
export type TemplateScreenUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  TemplateId?: string
  Title?: string
  Description?: string
  Order?: number
  Type?: string
  AiPrompt?: string
  AiOutputSchema?: string
  DynamicMaxFields?: number
  DynamicPrompt?: string
  SignatoryConfig?: string
  UilmDescriptionKey?: string
  UilmTitleKey?: string
  EnableApplyStandards?: boolean
  Conditions?: string
}

export type UpdateTemplateScreenResponse = {
  data: {
    updateTemplateScreens: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateTemplateScreen = () => {
  const mutation = useMutation({
    mutationKey: ['update-template-screen'],
    mutationFn: (variables: TemplateScreenUpdateInput) => {
      return graphqlClient.request<UpdateTemplateScreensMutation>(UpdateTemplateScreensDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateTemplateScreen: mutation.mutate,
    updateTemplateScreenAsync: mutation.mutateAsync,
  }
}

export const UPDATE_TEMPLATE_SCREEN_MUTATION = UpdateTemplateScreensDocument;
